import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';

function Header({ events, selectedEvent, onSelectEvent }) {
    const logoUrl = "great_eight_logo.png";
    const redirectUrl = "https://greateight.ch";

    return (
        <Navbar bg="light" variant="light" expand="lg" className="sticky-top border-bottom shadow-sm">
            <Container>
                <Navbar.Brand href={redirectUrl}>
                    <img
                        src={logoUrl}
                        width="60"
                        height="60"
                        className="d-inline-block align-top"
                        alt="Great Eight Logo"
                    />
                </Navbar.Brand>
                <Navbar.Text className="text-dark me-4">
                    <h3 className="mb-0">Ticketing</h3>
                </Navbar.Text>
                <Navbar.Toggle aria-controls="navbar-events" />
                <Navbar.Collapse id="navbar-events">
                    <Nav className="me-auto">
                        {events.map(event => (
                            <Nav.Link
                                key={event.id}
                                active={selectedEvent && selectedEvent.id === event.id}
                                onClick={() => onSelectEvent(event)}
                                style={{ fontSize: '1.2rem' }}
                            >
                                {event.title}
                            </Nav.Link>
                        ))}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
